import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarFeriadosDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class FeriadosBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Lista de Feriados">
                    <DataGrid
                        dataSource={criarFeriadosDs()}
                        showBorders={true}
                        rowAlternationEnabled={true} remoteOperations={true}
                        focusedRowEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={"cd_codigo"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'dia'} caption={"Dia"}/>
                        <Column dataField={'mes'} caption={"Mês"} />
                        <Column dataField={'tipoFeriado'} caption={"Tipo"} />
                        <Column dataField={'descricaoFeriado'} caption={"Descrição"} />
                        <Paging defaultPageSize={20} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 30]}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}
